// What build am I looking at?
//
// Two numbers doing two jobs. The RELEASE is semantic and chosen by hand in
// package.json when a batch of work is worth calling a release; it heads a
// CHANGELOG section and is what you say out loud. The BUILD is the commit and
// date behind it, stamped automatically on every deploy — a dozen builds can
// share one release, and when something looks wrong in production the commit
// is the part that actually identifies it.
//
// All three come from CI (see .github/workflows/firebase-hosting-merge.yml).
// A local `npm start` has none of them, which is why 'dev' is the fallback:
// a local build should never claim to be a released one.

export const RELEASE = process.env.REACT_APP_VERSION || 'dev';
export const COMMIT = process.env.REACT_APP_COMMIT || '';
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '';

/** e.g. "1.0.0 · 2026-08-25 · d3a83cb", or just "dev" locally. */
export const buildStamp = () =>
  [RELEASE, BUILD_DATE, COMMIT].filter(Boolean).join(' · ');

/** True when this bundle was built by CI rather than run locally. */
export const isDeployedBuild = () => RELEASE !== 'dev';
